// extracted by mini-css-extract-plugin
module.exports = {"plansHeader":"PlansHeader_plansHeader__RvjJH","plansHeader__title":"PlansHeader_plansHeader__title__zgYSi","plansHeader__icon":"PlansHeader_plansHeader__icon__FtVue"};